module.exports = __webpack_public_path__ + "static/img/activity02.5e29313c.png";